import auth from "@/api/auth";
import { removeToken } from "@/utils/token";
import {
  setUserInfo,
  removeUserInfo,
  setProviderType,
  removeProviderType,
} from "@/utils/user";
const user = {
  state: {
    userInfo: {},
    providerCopType: "",
  },
  mutations: {
    SET_USERINFO: (state, data) => {
      // 用户信息存在在cookie和vuex中
      state.userInfo = data;
      setUserInfo(data);
    },
    SET_PROVIDER_COP_TYPE: (state, data) => {
      state.providerCopType = data;
    },
  },
  actions: {
    async login(_, data) {
      const loginState = await auth.login(data);
      // const copTypeState = await auth.queryProviderCopType();
      if (loginState) {
        return loginState;
      } else {
        return false;
      }
    },
    async getUserInfo({ commit }) {
      const data = await auth.getUserInfo();
      commit("SET_USERINFO", data);
      return data;
    },
    logOut() {
      removeToken();
      removeUserInfo();
      removeProviderType();
    },
    changePassword({ dispatch }, data) {
      return auth.changePassword(data);
    },
    queryProviderCopType({ commit }) {
      return auth.queryProviderCopType().then((res) => {
        commit("SET_PROVIDER_COP_TYPE", res.value);
        setProviderType(res.value);
        return res.value;
      });
    },
  },
};

export default user;
